import { ref } from 'vue';

// Set when a 401 survives the token-refresh retry: the session is truly dead and only a fresh
// sign-in recovers it. The interceptor lives outside Vue, so this ref is the bridge. App.vue
// watches it for a global toast and views read it to swap in an inline "session expired" banner.
export const sessionExpired = ref(false);

export function markSessionExpired(): void {
  sessionExpired.value = true;
}
